var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimerPauseBtn = function SvgTimerPauseBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.044 0H1.956C.876 0 0 .876 0 1.956v6.088C0 9.124.876 10 1.956 10h6.088C9.124 10 10 9.124 10 8.044V1.956C10 .876 9.124 0 8.044 0"
  })));
};
export default SvgTimerPauseBtn;